import { createSelector } from 'reselect';

export const getImportsMedDRA = createSelector(state => state.MedDRAImports, u =>u);